export enum DataPage{
    raw = 1,
    result = 2,
    report = 3
}